module.exports = __webpack_public_path__ + "static/img/20250320002.198c80c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320002.jpg
// module id = LvPK
// module chunks = 0